// extracted by mini-css-extract-plugin
module.exports = {"center":"main_center__HymtH","logo":"main_logo__2Fy8_","donate":"main_donate__1W61v","btn":"main_btn__2c35-"};